function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { useCallback } from "react";
import styled from "styled-components";
import { Flex, Text } from "sprout-ui-primitives";
import { Menu, MenuItem, MenuTrigger, useMenuState } from "@sprout/list-navigation/dist/Menu";
import { Card as BaseCard } from "../Card";
const Card = styled(BaseCard)`
  display: flex;
  align-items: center;
`;
const Avatar = styled(Flex)`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  flex: none;
`;
const Email = styled(Text)`
  flex: auto;
  min-width: 0;
`;
function EmailCard(props) {
    const { email , onRemovingClick  } = props;
    const handleClick = useCallback((event)=>{
        onRemovingClick(event, email.id);
    }, [
        email.id,
        onRemovingClick
    ]);
    const menuState = useMenuState();
    return /*#__PURE__*/ _jsxs(Card, {
        children: [
            /*#__PURE__*/ _jsx(Avatar, {
                align: "center",
                justifyContent: "center",
                bg: "grey.200",
                children: /*#__PURE__*/ _jsx(Text, {
                    fontWeight: "bold",
                    caps: true,
                    fontSize: 3,
                    children: email.email.charAt(0)
                })
            }),
            /*#__PURE__*/ _jsx(Email, {
                ml: "16px",
                mr: "8px",
                fontSize: "18px",
                fontWeight: "bold",
                truncate: true,
                children: email.email
            }),
            /*#__PURE__*/ _jsx(Text, {
                fontSize: "15px",
                color: "black.60",
                mr: "4px",
                children: "Invited"
            }),
            onRemovingClick && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(MenuTrigger, _objectSpread({}, menuState)),
                    /*#__PURE__*/ _jsx(Menu, _objectSpread({}, menuState, {
                        children: /*#__PURE__*/ _jsx(MenuItem, {
                            onClick: handleClick,
                            label: "Remove from tree"
                        })
                    }))
                ]
            })
        ]
    });
}
EmailCard.propTypes = {
    email: PropTypes.shape({
        email: PropTypes.string.isRequired
    }).isRequired,
    onRemovingClick: PropTypes.func.isRequired
};
export default EmailCard;
